import { useTranslation } from 'react-i18next';
import { DatePicker, Form } from 'antd';
import * as yup from 'yup';
import FormModalStyled from '../../../core/components/modals/FormModalStyled';
import AForm from '../../../core/components/form/AForm';
import withModal from '../../../core/components/withModals';

const DeleteUserModal = (props) => {
  const { t } = useTranslation();
  const { modalProps, onSave, modalData } = props;
  const [form] = Form.useForm();
  const fields = [
    {
      key: 'dateTo',
      id: 'dateTo',
      name: t('users.dateTo'),
      render: <DatePicker />
    }
  ];

  const minDate = new Date();

  const validationSchema = yup.object().shape({
    dateTo: yup
      .date()
      .typeError(t('errors.invalidDate'))
      .required(t('errors.required'))
      .min(minDate, t('errors.dateInPast'))
  });

  return (
    <FormModalStyled
      centered
      maskClosable={false}
      width={550}
      footer={[]}
      {...modalProps}
      title={t('users.deleteUser')}
    >
      <div style={{ padding: '25px 25px 0px 25px', lineHeight: '150%' }}>
        <b><p>{t('users.deleteQuestion')}</p></b>
        <p>{t('users.deleteExplanation')}</p>
      </div>
      <AForm
        form={form}
        fields={fields}
        okButtonText={t('buttons.confirm')}
        validationSchema={validationSchema}
        modalAddHandler={async (formData, setLoading) => {
          setLoading(true);
          await onSave({
            id: modalData?.id,
            dateTo: new Date(formData?.dateTo).toISOString().substring(0, 10)
          });
          setLoading(false);
        }}
      />
    </FormModalStyled>
  )
}

export default withModal()(DeleteUserModal);
